import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const userDefaultValues = { email: '', role: '' };

const userSchema = yup.object({
  email: yup.string().required('Email is required').email('Invalid email address'),
  role: yup.string().required('Role is required').oneOf(['Admin', 'Operator'], 'Invalid role')
});

export function useUserForm(options?: { initialUser?: { email: string; role: string } }) {
  const defaultValues = options?.initialUser || userDefaultValues;
  return useForm<{ email: string; role: string }>({
    mode: 'onSubmit',
    resolver: yupResolver(userSchema),
    defaultValues
  });
}
